module.exports = __webpack_public_path__ + "img/20220331_102045.4b45181a.jpg";